import { httpRequest, endpoint } from "@cirrus/core/http"

export const createPOST = async ({ params }) =>
  await httpRequest.post(endpoint.withRoot(`/api/v1/author/proctoriotemplate/create`), params)

export const getListGET = async ({ params }) =>
  await httpRequest.get(
    endpoint.withRoot(
      `/api/v1/author/proctoriotemplate?sort=SortByLastModified&sortByDescending=${params}`,
    ),
    params,
  )

export const itemPATCH = async ({ params }) =>
  await httpRequest.patch(
    endpoint.withRoot(`/api/v1/author/proctoriotemplate/${params.id}`),
    params,
  )

export const itemGET = async ({ params }) =>
  await httpRequest.get(endpoint.withRoot(`/api/v1/author/proctoriotemplate/${params}`))

export const itemActivatePATCH = async ({ params }) =>
  await httpRequest.patch(endpoint.withRoot(`/api/v1/author/proctoriotemplate/activate`), params)

export const itemDeactivatePATCH = async ({ params }) =>
  await httpRequest.patch(endpoint.withRoot(`/api/v1/author/proctoriotemplate/deactivate`), params)
